import { render } from "./ShowTransaction.vue?vue&type=template&id=58afb2fe&scoped=true"
import script from "./ShowTransaction.vue?vue&type=script&lang=js"
export * from "./ShowTransaction.vue?vue&type=script&lang=js"

import "./ShowTransaction.vue?vue&type=style&index=0&id=58afb2fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58afb2fe"]])

export default __exports__